import { render, staticRenderFns } from "./New Course Page Template.vue?vue&type=template&id=b3696230&scoped=true&"
var script = {}
import style0 from "./New Course Page Template.vue?vue&type=style&index=0&id=b3696230&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3696230",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UIHeader: require('/opt/build/repo/components/UI/Header.vue').default,UIFooter: require('/opt/build/repo/components/UI/Footer.vue').default})
